import React, {useState, useEffect} from 'react';
import {Container, Grid, Typography, Button} from '@material-ui/core/';
import { useStyles } from "./style";
import Alert from 'react-s-alert';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import IconElement from 'component/IconoInstitucional'; 
import BotonElement from 'component/BotonCancelar'; 
import Mensaje from '../../../component/MensajeElement'
import LoadingProgress from 'component/Loading'
import {Lock, Cancel} from '@material-ui/icons/';
import { useHistory } from "react-router-dom";
import ApiServices from 'service/ApiServices';
import BotonPersonalizado from 'component/BotonNormal'

function ObtenerCodigoCambiarcontraseña(props) {
    const classes = useStyles();
    const [correo, setCorreo] = useState(props.currentUser.email)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''})

    let history = useHistory();

    const ObtenerCodigo = async () =>{
        setLoading(true);
        try{
            const sendCode = Object.assign({}, {"email": correo});
            const response =  await ApiServices.userChangePasswordRequest.sendCode(sendCode);

            if (response.error!==null){
                props.MENSAJE_CODIGO(response.error.message)
                setOpen(true)
                setMensaje({tipoError:'error', tipoMensaje:response.error.message})
                setLoading(false);
                history.push("/cambiarContraseña",{})
            }else{
                props.MENSAJE_CODIGO(response.data)
                setOpen(true)
                setMensaje({tipoError:'success', tipoMensaje: response.data})                        
                setLoading(false);                
                history.push("/cambiarContraseña",{})
            }   
        }catch(exception){
            if(exception.status===404){ 
                Alert.warning("Intente de nuevo")
                setLoading(false);
            }else{
                Alert.error("Intente de nuevo ");
                setLoading(false);
            }
        }                    
    }

    const Cancelar = () =>{
        history.push("/",{})
    }

    const handClose = (event, reason) =>{
        if (reason === 'clickaway') {return ;}
        setOpen(false)
    }

    return (
        <div className={classes.root}>
            <Container maxWidth="md" className={classes.colorComponente}>
                <br/>
                <Grid container >
                    <IconElement/>
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                        <Mensaje type={mensaje.tipoError} content={mensaje.tipoMensaje} open={open} handClose={handClose} />
                    </Grid>                    
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body2" color="textPrimary"> <strong>Necesitamos comprobar tu identidad</strong></Typography><br/><br/>
                    </Grid>
                    <Grid className={classes.marginText} item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body2" color="textPrimary">Enviaremos un código de seguridad a su correo electrónico registrado.</Typography><br/><br/>
                    </Grid>
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body2" color="textPrimary"><strong>{correo}</strong></Typography><br/><br/>
                    </Grid>

                    <Grid className={classes.marginBoton} item xs={12} container direction="row" justify="center" alignItems="center">
                        <BotonPersonalizado title={"Obtener Código"}  botonPersonalizado={true} function={ObtenerCodigo} icon={<Lock />}/>
                        <BotonPersonalizado title={"Cancelar"}  botonNormalCancelar={true} function={Cancelar}/>
                    </Grid>                    
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
                <LoadingProgress open={loading} text="Enviando código de seguridad ..."/>
            </Container>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ObtenerCodigoCambiarcontraseña);